// manageStudentsReducer.js

import {
  FETCH_MANAGE_COURSES_REQUEST,
  FETCH_MANAGE_COURSES_SUCCESS,
  FETCH_MANAGE_COURSES_FAILURE,
} from "../Actions/types";

const initialState = {
  loading: false,
  enrolledCourses: [],
  error: null,
};

const manageStudentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MANAGE_COURSES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_MANAGE_COURSES_SUCCESS:
      return { ...state, loading: false, enrolledCourses: action.payload };
    case FETCH_MANAGE_COURSES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default manageStudentsReducer;
